import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../../utils/historyUtils';

export default function(ComposedComponent) {
  class Authentication extends Component {
    componentDidMount() {
      if (!this.props.authenticated) {
        history.push('/signin');
      }
    }

    componentDidUpdate(nextProps) {
      if (!nextProps.authenticated) {
        history.push('/signin');
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.auth.authenticated
    };
  }

  return connect(mapStateToProps)(Authentication);
}
